
<template>
    <div class="spinner">
        <div class="selector">
            <button class="btn-selector" v-on:click="onDecrement()">-</button>
            <span class="value">{{value}}</span>
            <button class="btn-selector" v-on:click="onIncrement()">+</button>
        </div>
        <label>
            {{label}}
        </label>
    </div>


</template>



<script>

    export default {
        name: 'Spinner',
        props: {
            label: String,
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 4
            },
            initial: Number
        },
        computed: {
            value: {
                get() {
                    return this.initial;
                },
                set(val) {
                    this.$emit('valueChange', val);
                }
            }
        },
        methods: {
            onIncrement() {
                if (this.value < this.max) {

                    this.value = this.value + 1;

                }

            },
            onDecrement() {
                if (this.value > this.min) {

                    this.value = this.value - 1;
                }
            }
        }
    }
</script>

<style>
    .spinner {
        width: 100%;
        display: flex;
        flex-direction: column;
    }



        .spinner label {
            text-transform: none !important;
            margin-top: 10px;
        }

        .spinner .selector {
            display: flex;
            justify-content: space-between;
            padding: 5px;
            border: solid 1px #e4e5ea;
        }

            .spinner .selector .btn-selector {
                height: 100%;
                background-color: transparent;
                border: none;
                padding: 0;
            }
</style>